import { Redirect } from "@shopify/app-bridge/actions";
import { useAppBridge, Loading } from "@shopify/app-bridge-react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CircleLoader from "components/CircleLoader";
import config from "config";
import { Notice } from "components/Notice";

export default function ExitIframe() {
  const app = useAppBridge();
  const { search } = useLocation();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!!app && !!search) {
      const params = new URLSearchParams(search);
      const redirectUri = params.get("redirectUri");
      const url = new URL(decodeURIComponent(redirectUri));
      const baseUrl = new URL(config.baseUrl);
      const apiUrl = new URL(config.apiUrl);
      if (
        url.hostname === apiUrl.hostname
        || url.hostname === window.location.hostname 
        || url.hostname === baseUrl.hostname
      ) {
        const redirect = Redirect.create(app);
        setTimeout(()=>{
          redirect.dispatch(
            Redirect.Action.REMOTE,
            decodeURIComponent(redirectUri)
          );
        }, 10)
      }else{
        setError("Invalid hostname")
        console.log({
          'url': url.hostname, 
          'base': baseUrl.hostname, 
          'api': apiUrl.hostname, 
          'window': window.location.hostname
        })
      }
    }
  }, [app, search]);

  return (
    <>{error !== null ? (
      <Notice color="error">{error}</Notice>
      ) : (
      <CircleLoader />
      )
    }</>);
}
